import { Address } from "@app/models/Address";
import { FeaturesService } from "@app/services/Features.service";
import { HeaderService } from "@app/components/header/header.service";
import { CountryCode } from "@app/models/CountryCode";
import { Homeowner } from "@app/models/Homeowner";
import { Property } from "@app/models/Property";
import { ContactApi } from "@app/services/apiServices/ContactApi";
import { HomeownerApi } from "@app/services/apiServices/HomeownerApi";
import { PropertyApi } from "@app/services/apiServices/PropertyApi";
import { NetworkErrorService } from "@app/services/NetworkError.service";
import { SpinnerService } from "@app/services/spinner.service";
import { GuestPaymentStore } from "@app/services/stores/GuestPaymentStore";
import { PaymentEntityType } from "@app/models/PaymentEntityType";
import { AmenityApi } from "@app/services/apiServices/AmenityApi";
import { ValidationResponse } from "@app/models/ValidationResponse";
import { RegistrationStore } from '@app/pages/registration/stores/RegistrationStore';
import { Observable, of, Subject } from "rxjs";
import { catchError, map, take } from "rxjs/operators";
import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { RegistrationInvalidAddressDialog } from "@app/pages/registration/registrationDialogInvalidAddress.component";
import { RegistrationNoPropertyDialog } from "@app/pages/registration/registrationDialogNoProperty.component";
import { RegistrationAltAddressDialog } from "@app/pages/registration/registrationDialogAltAddress.component";
import { DialogErrorDialog } from "@app/components/sharedDialogs/dialogError.dialog";
import { OneButtonDialogComponent } from "@app/components/sharedDialogs/oneButtonDialog.component";
import { RegistrationStopProcessDialog } from "@app/pages/registration/registrationDialogStopProcess.component";
import { WindowToken } from "@app/util/window.token";
import { DomSanitizer } from "@angular/platform-browser";
import { AppDataService } from "@app/services/appData.service";
import { PersonalInfoData } from "@app/components/personalInfo/personalInfo.directive";
import { ActivatedRoute, Router } from "@angular/router";
import { TermsDialog } from "@app/pages/registration/terms.dialog";
import { ErrorHandlerService } from "@app/services/ErrorHandler.service";

const HOMEOWNER_ZERO_VALUE: Homeowner = {
    firstName: "",
    lastName: "",
    id: null,
    version: null,
    contactInformation: {
        email: { value: "" },
        phones: [{ type: "", countryCallingCode: "USA", value: "" }],
        notifyBySms: false,
    }
}

@Component({
    selector: 'app-guest-payment',
    template: require('./guestpayment.html')
})

export class GuestPaymentComponent implements OnInit {
    homeowner: Homeowner;
    property: Property;
    countryCode: CountryCode;
    emailAddressExists = false;  // (MMDP-1970: email-address-exists="emailAddressExists" removed until Registered User functionality is enabled.)
    paymentEntityType: PaymentEntityType;
    paymentEntityTypes = PaymentEntityType;

    getWebUrl: () => string;
    getPmcContactUrl = (pmcId: string) => this.getWebUrl() + `/guest/#/contact/?pmcId=${pmcId}`;
    pmcDataName = "";
    invalidVar: boolean;
    isLoadingFindMyProperty: boolean = false;
    invalidCheckVar: boolean = false;
    isHoaHomeowner: boolean = false;
    isCorrectingAddress: boolean = false;
    allowPayByCheck: boolean = true;
    allowPayByCard: boolean = true;
    personalInfoData: PersonalInfoData;
    emailAddressError: boolean = false;
    setPropertyAddressSubject: Subject<void> = new Subject<void>();

    constructor(
        @Inject(WindowToken) public window,
        @Inject(AppDataService) private appDataService: AppDataService,
        @Inject(PropertyApi) private propertyApi: PropertyApi,
        @Inject(MatDialog) private dialog: MatDialog,
        @Inject(HeaderService) private HeaderService: HeaderService,
        @Inject(GuestPaymentStore) private GuestPaymentStore: GuestPaymentStore,
        @Inject(HomeownerApi) private HomeownerApi: HomeownerApi,
        @Inject(NetworkErrorService) private NetworkErrorService: NetworkErrorService,
        @Inject(ErrorHandlerService) private errorHandlerService: ErrorHandlerService,
        @Inject(SpinnerService) private SpinnerService: SpinnerService,
        @Inject(ContactApi) private ContactApi: ContactApi,
        @Inject(FeaturesService) private FeaturesService: FeaturesService,
        @Inject(AmenityApi) private amenityApi: AmenityApi,
        @Inject(RegistrationStore) private registrationStore: RegistrationStore,
        @Inject(DomSanitizer) private domSanitizer: DomSanitizer,
        @Inject(Router) private router: Router,
        @Inject(ActivatedRoute) private activatedRoute: ActivatedRoute) {

        this.paymentEntityType = this.activatedRoute.snapshot.data.paymentEntityType;
    }

    ngOnInit() {
        this.getWebUrl = () => this.appDataService.appConfig.get_APP_ENV().HOAPASS_WEB_URL;
        this.HeaderService.setDisplayRightContent(false);

        // get current homeowner or default to empty values
        this.homeowner = this.getHomeownerFromStore();
        this.property = this.GuestPaymentStore.getProperty() || { address: {}, hoa: { pmc: {} } };

        this.invalidVar = false;

        if (!this.GuestPaymentStore.getViewedTc()) {
            let dialog= this.dialog.open(TermsDialog,{
                closeOnNavigation: false,
                disableClose: true,
                maxHeight: 'initial !important'
            });
            dialog.afterClosed().pipe(take(1)).subscribe((data) => {
                if (data === 'Y') {
                    this.GuestPaymentStore.setViewedTc(true);
                } else {
                    this.window.location.replace("/");
                }
            })
        }

        if (this.isCouponDataPresent()) {
            this.validateProperty();
        }

        this.personalInfoData = {
            homeowner: this.homeowner,
            emailAddressExists: this.emailAddressExists,
            isHoaHomeowner: this.isHoaHomeowner,
            useAnonymousApi: true,
            registration: false
        }
    }

    getHomeownerFromStore(): Homeowner {
        let homeowner = HOMEOWNER_ZERO_VALUE;
        let storedHomeowner = this.GuestPaymentStore.getHomeowner();

        if (storedHomeowner) {
            // not including id attributes since we don't want to
            // update an existing homeowner by id through this page
            homeowner.firstName = storedHomeowner.firstName;
            homeowner.lastName = storedHomeowner.lastName;
            homeowner.contactInformation.email.value = storedHomeowner.contactInformation.email.value;
            homeowner.contactInformation.phones[0].type = storedHomeowner.contactInformation.phones[0].type;
            homeowner.contactInformation.phones[0].countryCallingCode = storedHomeowner.contactInformation.phones[0].countryCallingCode;
            homeowner.contactInformation.phones[0].value = storedHomeowner.contactInformation.phones[0].value;
        }

        return homeowner;
    }

    getDefaultNickname(property: Property): string | undefined {
        if (property && property.address && property.address.line1?.length > 0) {
            return property.address.line1;
        }
    }

    isCouponDataPresent(): boolean {
        return this.property &&
            this.property.couponId?.length > 0 &&
            this.property.hoa?.couponId?.length > 0 &&
            this.property.hoa?.pmc?.couponId?.length > 0;

    }

    isAddressPresent(): boolean {
        return this.property
            && this.property.address?.line1?.length > 0
            && this.property.address?.city?.length > 0
            && this.property.address?.state?.length > 0
            && this.property.address?.postalCode?.length > 0;
    }

    isPhoneNumberValid() {
        const phones = this.homeowner.contactInformation.phones;
        const value = phones && phones[0] && phones[0].value;
        if (value) {
            const onlyDigitsValue = value.replace(/[^0-9]+/g, '');

            if (this.homeowner.contactInformation.phones[0].countryCallingCode === 'USA') {
                return onlyDigitsValue.length === 10;
            } else {
                return onlyDigitsValue.length >= 7;
            }
        }
        return false;
    }

    isPersonalInfoPresent() {
        this.homeowner = this.personalInfoData.homeowner;

        if (this.homeowner &&
            this.homeowner.firstName &&
            this.homeowner.lastName &&
            this.homeowner.contactInformation &&
            this.homeowner.contactInformation.email.value) {
            return this.isPhoneNumberValid();
        } else {
            return false;
        }
    }

    isAddressFieldValid(value) {
        return value && value.length > 0 && value.toLowerCase() !== 'null'
    }

    isAddressValid(address: Address) {
        return (this.isAddressFieldValid(address.line1) || this.isAddressFieldValid(address.addressLine1))
            && this.isAddressFieldValid(address.city)
            && this.isAddressFieldValid(address.state)
            && this.isAddressFieldValid(address.postalCode)
            && new RegExp('^[0-9]{5}$').test(address.postalCode);
    }

    startCorrectingAddress() {
        this.isCorrectingAddress = true;
    }

    stopCorrectingAddress() {
        this.isCorrectingAddress = false;
    }

    cleanAddress(address: Address) {
        if (address.postalCode !== null) {
            address.postalCode = address.postalCode.substr(0, 5);
        }
    }

    setPropertyAddress(address: Address) {
        this.cleanAddress(address);
        if (!this.isAddressValid(address)) {
            this.startCorrectingAddress();
        } else {
            this.stopCorrectingAddress();
        }

        this.property.address = address;
        this.setPropertyAddressSubject.next();
    }

    setAllowCheckAndCard(allowPayByCheck: boolean, allowPayByCard: boolean) {
        this.allowPayByCheck = allowPayByCheck;
        this.allowPayByCard = allowPayByCard;
    }

    defaultPropertyAddress(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            if (!this.isCouponDataPresent()) {
                return reject();
            }
            if (this.isCorrectingAddress) {
                return resolve();
            }
            this.propertyApi.propertyAddressGet(
                true,
                this.property.hoa.pmc.couponId,
                this.property.hoa.couponId,
                this.property.couponId).pipe(take(1)).subscribe({
                next: (addrResp) => {
                    const addressExists = addrResp?.line1
                    if (!addressExists) {
                        this.propertyApi.propertiesValidateGet(
                            true,
                            this.property.hoa.pmc.couponId,
                            this.property.hoa.couponId,
                            this.property.couponId).pipe(take(1)).subscribe({
                            next: (validateResp) => {
                                if (validateResp.valid === true) {
                                    this.setPropertyAddressSubject.next();
                                    return resolve();
                                }
                                else return reject('Invalid property');
                            },
                            error: err => {
                                return reject('Invalid property');
                            }
                        });
                        return null
                    }

                    if (addrResp.amountDue != null) {
                        this.GuestPaymentStore.setPropertyAmountDue(this.property, addrResp.amountDue);
                        delete addrResp.amountDue;
                    }

                    const addressFromApi = this.ensureAddressLines(addrResp)

                    if (addressFromApi == null) return reject('Invalid property');

                    if (!this.isAddressPresent()) {
                        // if address not present, we don't have to populate that information
                        // so resolve and return
                        this.setPropertyAddress(addressFromApi);
                        this.property.nickname = this.getDefaultNickname(this.property);
                        this.GuestPaymentStore.setProperty(this.property)

                        return resolve();
                    }

                    const isAddressUnchanged = this.isAddressEqual(addressFromApi, this.property.address);
                    if (isAddressUnchanged) {
                        return resolve();
                    }

                    // Retrieve pmc details
                    this.ContactApi.pmcOrganizationDetailsGET(true, this.property.hoa.pmc.couponId)
                        .subscribe((data) => {
                            if (data == null) {
                                return reject('No pmc found with Coupon ID: ' + this.property.hoa.pmc.couponId);
                            }

                            this.pmcDataName = data.name;
                            const pmcCouponId = this.property.hoa.pmc.couponId;

                            let propertyAddress = renderAddressForDialog(addressFromApi);

                            let dialog: MatDialogRef<any>;
                            if (!this.isAddressValid(addressFromApi)) {
                                dialog = this.dialog.open(RegistrationAltAddressDialog, {
                                    data: {
                                        propertyAddress: this.domSanitizer.bypassSecurityTrustHtml(propertyAddress),
                                        contactUrl: this.getPmcContactUrl(pmcCouponId),
                                        pmcName: this.pmcDataName
                                    }
                                });
                            } else {
                                dialog = this.dialog.open(RegistrationAltAddressDialog, {
                                    data: {
                                        propertyAddress: this.domSanitizer.bypassSecurityTrustHtml(propertyAddress),
                                        contactUrl: this.getPmcContactUrl(pmcCouponId),
                                        pmcName: this.pmcDataName
                                    }
                                });
                            }
                            dialog.afterClosed().pipe(take(1)).subscribe((data) => {
                                if (data === 'A') {
                                    this.setPropertyAddress(addressFromApi);
                                    // save info
                                    this.GuestPaymentStore.setProperty(this.property)

                                    return resolve();
                                } else {
                                    return reject('Invalid property');
                                }
                            });
                        });
                },
                error: err => {
                    this.NetworkErrorService.handleNetworkError(err, true).pipe(take(1)).subscribe((resp) => {
                        if (resp === true) {
                            // chose retry
                            this.defaultPropertyAddress();
                        } else {
                            return reject();
                        }
                    });
                }
            });
        })
    }

    private isAddressEqual(a: Address, b: Address) {
        if (!a) throw new ReferenceError('Passed in invalid address A for comparison')
        if (!b) throw new ReferenceError('Passed in invalid address B for comparison')
        const isLine1Equal = b.line1 === a.line1;
        const isLine2Equal = (b.line2 == null && a.line2 == null) || b.line2 === a.line2;
        const isCityEqual = b.city === a.city;
        const isStateEqual = b.state === a.state;
        const isPostalCodeEqual = b.postalCode === a.postalCode;

        return isLine1Equal && isLine2Equal && isCityEqual && isStateEqual && isPostalCodeEqual;
    }

    private ensureAddressLines(address: Address): Address {
        const line1 = address.line1 || address.addressLine1
        const line2 = address.line2 || address.addressLine2
        return { addressLine1: line1, addressLine2: line2, line1, line2, ...address }
    }

    validateProperty() {
        this.propertyApi.propertiesValidateGet(
            true,
            this.property.hoa.pmc.couponId,
            this.property.hoa.couponId,
            this.property.couponId)
            .pipe(take(1)).subscribe((validateResp) => {
                this.setAllowCheckAndCard(validateResp.achPayments, validateResp.cardPayments);
                this.GuestPaymentStore.setDelayTodaysPayment(validateResp.delayPayment);
            });
    }

    clearAmenities() {
        this.GuestPaymentStore.clearPaymentRequest();
    }

    propertyFormLeftChange() {
        this.stopCorrectingAddress();
        if (this.isCouponDataPresent()) {
            this.validateProperty();
        }
        this.clearAmenities();
        this.defaultPropertyAddress().then(() => {})
            .catch((err) => {
                if (err === "Invalid property" && !this.invalidVar) {
                    // Retrieve pmc details
                    this.ContactApi.pmcOrganizationDetailsGET(true, this.property.hoa.pmc.couponId).subscribe({
                        next: data => {
                            if (data != null) {
                                this.pmcDataName = data.name;
                                this.dialog.open(RegistrationNoPropertyDialog, {
                                    data: {
                                        pmcId: this.property.hoa.pmc.couponId,
                                        pmcName: this.pmcDataName
                                    }
                                });
                            }
                        },
                        error: err1 => { console.error('Issue Getting Org Details', err1);}
                    })

                    this.isLoadingFindMyProperty = false;
                    this.SpinnerService.closeSpinner();
                }
            });
    }

    invalidCheck(addressError) {
        if (addressError.searching != null) {
            this.isLoadingFindMyProperty = addressError["searching"];
        }

        for (let key in addressError) {
            if (addressError[key]) {
                this.invalidVar = true;
                return;
            }
        }

        this.invalidVar = false;
    }

    invalid() {
        return !this.isCouponDataPresent() || !this.isAddressPresent() || !this.isPersonalInfoPresent() || this.invalidVar || this.isLoadingFindMyProperty;
    }

    registerNow() {
        this.GuestPaymentStore.setHomeowner(this.homeowner);
        if (this.property !== null && this.property !== undefined && this.property.hoa !== null && this.property.hoa.pmc !== null) {
            this.GuestPaymentStore.setProperty(this.property);
            this.router.navigateByUrl('/registerStep2');
        }
        else {
            this.router.navigateByUrl('/register');
        }
    }

    cancel() {
        this.GuestPaymentStore.clearAllGuest();
        this.window.location.replace("/");
    }

    validateAmenities(pmcCouponId: string, hoaCouponId: string, propertyCouponId: string, paymentEntityType: PaymentEntityType): Observable<boolean> {
        if (paymentEntityType === PaymentEntityType.AMENITY) {
            return this.amenityApi.activeAmenitiesByCouponGet(true, pmcCouponId, hoaCouponId, propertyCouponId)
                .pipe(take(1),
                    map(response => {return response.length !== 0}),
                    catchError(() => {return of(false)})
                )
        } else {
            return of(true);
        }
    }

    isOnHold(validationResponse: ValidationResponse): boolean {
        if (this.paymentEntityType === PaymentEntityType.AMENITY && validationResponse.doNotProcessCode === "L01")
            return false;

        return validationResponse.doNotProcess
    }

    registerGuestNow() {
        this.registrationStore.setHomeowner(this.homeowner);
        this.router.navigateByUrl('/register');
    }

    submit(type?: 'check' | 'card') {
        if (this.invalid()) {
            this.invalidVar = true
            return;
        }

        this.SpinnerService.showSpinner();
        this.defaultPropertyAddress().then(() => {
            //validating because defaultPropertyAddress will change the address
            if (!this.isAddressValid(this.property.address)) {
                this.SpinnerService.closeSpinner();
                this.dialog.open(RegistrationInvalidAddressDialog);
                return;
            }

            this.validateAmenities(this.property.hoa.pmc.couponId, this.property.hoa.couponId, this.property.couponId, this.paymentEntityType)
                .subscribe({
                    next: () => {
                        this.propertyApi.propertiesValidateGet(
                            true,
                            this.property.hoa.pmc.couponId,
                            this.property.hoa.couponId,
                            this.property.couponId).pipe(take(1)).subscribe((resp) => {
                            if ((type === 'card' && resp.cardPayments === false)
                            || (type === 'check' && resp.achPayments === false)) {
                                this.SpinnerService.closeSpinner();
                                this.dialog.open(DialogErrorDialog, {
                                    data: { error: 'Invalid Payment Type.' }
                                });
                                return;
                            }

                            if (resp.valid === true) {
                                this.homeowner.contactInformation.mailingAddress = this.property.address;
                                this.GuestPaymentStore.setProperty(this.property);
                                this.GuestPaymentStore.setHomeowner(this.homeowner);
                                if (this.isOnHold(resp)) {

                                    // Retrieve pmc details
                                    this.ContactApi.pmcOrganizationDetailsGET(true, this.property.hoa.pmc.couponId)
                                        .subscribe({
                                            next: data  => {
                                                if (resp != null) {
                                                    this.pmcDataName = data.name;
                                                } else {
                                                    this.dialog.open(DialogErrorDialog, {
                                                        data: { error: 'Could not retrieve PMC data.' }
                                                    });
                                                    this.SpinnerService.closeSpinner();
                                                    return;
                                                }
                                                const pmcCouponId = this.property.hoa.pmc.couponId;

                                                this.dialog.open(RegistrationStopProcessDialog, {
                                                    data: {
                                                        reasonCode: resp?.doNotProcessCode,
                                                        contactUrl: this.getPmcContactUrl(pmcCouponId),
                                                        pmcName: this.pmcDataName
                                                    }
                                                });
                                                this.SpinnerService.closeSpinner();
                                                return;
                                            },
                                            error: err => {
                                                this.NetworkErrorService.handleNetworkError(err, true).pipe(take(1)).subscribe();
                                                this.SpinnerService.closeSpinner();
                                                return;
                                            }
                                        });
                                    return;
                                }
                            } else {
                            // Retrieve pmc details
                                this.ContactApi.pmcOrganizationDetailsGET(true, this.property.hoa.pmc.couponId)
                                    .subscribe({
                                        next: data => {
                                            if (data != null) {
                                                this.pmcDataName = data.name;
                                            } else {
                                                this.dialog.open(DialogErrorDialog, {
                                                    data: { error: 'Could not retrieve PMC data.' }
                                                });
                                                this.SpinnerService.closeSpinner();
                                                return;
                                            }
                                            const pmcCouponId = this.property.hoa.pmc.couponId;

                                            if (resp.message === 'No matching record found.') {
                                                this.dialog.open(RegistrationNoPropertyDialog, {
                                                    data: {
                                                        pmcId: this.property.hoa.pmc.couponId,
                                                        pmcName: this.pmcDataName
                                                    }
                                                });
                                            } else {
                                                this.dialog.open(RegistrationStopProcessDialog, {
                                                    data: {
                                                        reasonCode: resp.doNotProcessCode,
                                                        contactUrl: this.getPmcContactUrl(pmcCouponId),
                                                        pmcName: this.pmcDataName
                                                    }
                                                });
                                            }
                                            this.SpinnerService.closeSpinner();
                                            return;
                                        },
                                        error: err => {
                                            this.NetworkErrorService.handleNetworkError(err, true).pipe(take(1)).subscribe((resp) => {
                                                if (resp === true) {
                                                    this.submit(type);
                                                }
                                            });
                                        }
                                    })
                            }
                            const email = this.homeowner.contactInformation.email;
                            const firstName = this.homeowner.firstName;
                            const lastName = this.homeowner.lastName;
                            const phone = this.homeowner.contactInformation.phones[0];
                            this.HomeownerApi.guestHomeownersIdPost(true, this.homeowner)
                                .pipe(take(1)).subscribe({
                                    next: data => {
                                        if (data != null) {

                                            this.homeowner = data;
                                            this.homeowner.firstName = firstName;
                                            this.homeowner.lastName = lastName;
                                            this.homeowner.contactInformation.email = email;
                                            this.homeowner.contactInformation.phones[0] = phone;

                                            // save details
                                            this.GuestPaymentStore.setHomeowner(this.homeowner);
                                            this.GuestPaymentStore.setProperty(this.property);

                                            this.propertyApi.homeownersIdPropertiesPost(true, this.homeowner.id, this.property).pipe(take(1))
                                                .subscribe((resp) => {
                                                    if (resp != null && resp.body != null) {
                                                        this.property.id = resp.body.id;
                                                        this.property.hoa.name = resp.body.hoa.name;
                                                        this.property.hoa.pmc.name = resp.body.hoa.pmc.name;
                                                        this.GuestPaymentStore.setProperty(this.property);
                                                        this.SpinnerService.closeSpinner();
                                                        let url;
                                                        if (this.paymentEntityType === PaymentEntityType.AMENITY) {
                                                            url = '/amenities/select';
                                                        } else {
                                                            url = type === 'check' ? '/guestpaymentecheck' :'/guestpaymentcard';
                                                        }
                                                        this.router.navigateByUrl(url);
                                                    } else {
                                                        this.dialog.open(DialogErrorDialog, {
                                                            data: { error: 'Could not save the property.' }
                                                        });
                                                        this.SpinnerService.closeSpinner();
                                                        return;
                                                    }
                                                }, (err) => {

                                                    if (err.message === 'Account is on HOLD.' || /account is on hold/i.test(err.message)) {
                                                        const pmcCouponId = this.property.hoa.pmc.couponId;

                                                        this.dialog.open(RegistrationStopProcessDialog, {
                                                            data: {
                                                                errorCode: err.doNotProcessCode,
                                                                contactUrl: this.getPmcContactUrl(pmcCouponId),
                                                                pmcName: this.pmcDataName
                                                            }
                                                        });
                                                        this.SpinnerService.closeSpinner();
                                                        return;
                                                    } else {
                                                        let errorMessage = '';
                                                        if (err.error.message) errorMessage = err.error.message;
                                                        if (err.error.errors && err.error.errors.length > 0) {
                                                            err.error.errors.forEach(msg => {
                                                                errorMessage += '<br><br>' + msg;
                                                            })
                                                        }
                                                        this.NetworkErrorService.handleNetworkError(errorMessage, true)
                                                            .pipe(take(1)).subscribe((resp) => {
                                                                if (resp === true) {
                                                                    this.submit(type);
                                                                }
                                                            });
                                                    }
                                                });
                                        } else {
                                            this.dialog.open(DialogErrorDialog, {
                                                data: { error: 'Error trying to save homeowner.' }
                                            });
                                            this.SpinnerService.closeSpinner();
                                            return;
                                        }
                                    },
                                    error: err => {
                                        this.NetworkErrorService.handleNetworkError(err, true)
                                            .pipe(take(1)).subscribe((resp) => {
                                                if (resp === true) {
                                                    this.submit(type);
                                                }
                                            });
                                    } });
                        }, (err) => {
                            this.NetworkErrorService.handleNetworkError(err, true)
                                .pipe(take(1)).subscribe((resp) => {
                                    if (resp === true) {
                                        this.submit(type);
                                    }
                                });
                        });
                    },
                    error: () => {
                        this.dialog.open(OneButtonDialogComponent, {
                            data: {
                                buttonText: 'Okay',
                                header: 'No Amenities',
                                message: 'The property you entered does not have any available amenities.'
                            }
                        });
                        this.SpinnerService.closeSpinner();
                    } })
        }, (err) => {
            if (err === 'Invalid property') {
                // Retrieve pmc details
                this.ContactApi.pmcOrganizationDetailsGET(true, this.property.hoa.pmc.couponId)
                    .subscribe({
                        next: data => {
                            if (data != null) {
                                this.pmcDataName = data.name;
                                this.dialog.open(RegistrationNoPropertyDialog, {
                                    data: {
                                        pmcId: this.property.hoa.pmc.couponId,
                                        pmcName: this.pmcDataName
                                    }
                                });
                            }
                        },
                        error: err => {
                            this.NetworkErrorService.handleNetworkError(err, true)
                                .pipe(take(1)).subscribe((resp) => {
                                    if (resp === true) {
                                        this.submit(type);
                                    }
                                });
                        }
                    });
            }
            this.SpinnerService.closeSpinner();
        });
    }

    emailAddressValid(invalidObj) {
        for (let key in invalidObj) {
            if (invalidObj[key]) {
                this.invalidCheckVar = true;
                return;
            }
        }
        this.invalidCheckVar = false;
    }
}

function renderAddressForDialog(addressFromApi: Address) {
    let propertyAddress = "Address Line 1: " + addressFromApi.addressLine1 + "<br>";
    if (addressFromApi.addressLine2)
        propertyAddress += "Address Line 2: " + addressFromApi.addressLine2 + "<br>";
    if (addressFromApi.unit)
        propertyAddress += "Unit#: " + addressFromApi.unit + "<br>";
    propertyAddress += "City: " + addressFromApi.city +
        "<br> State: " + addressFromApi.state +
        "<br>Postal Code: " + addressFromApi.postalCode;

    return propertyAddress;
}

